import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SortDetails } from '../../models/sort-details-model';
import { ResultColumnsService } from '../../services/result-columns.service';

@Component({
  selector: 'app-sort-select-panel',
  templateUrl: './sort-select-panel.component.html',
  styleUrls: ['./sort-select-panel.component.css']
})
export class SortSelectPanelComponent implements OnInit {

  @Input() selectedCols: any[] = [];
  @Input() selectedSortColumn: any;
  @Input() selectedSortDirection: any;
  @Input() selectedSortCols: any[] = [];

  @Output() executeSort = new EventEmitter<any>();
  @Output() executeSortReset = new EventEmitter<any>();

  sortDirectionOptions = [{ name: "Descending", value: -1 }, { name: "Ascending", value: 1 }];
  showSortReset: boolean = false;
  accessionNumberColumn = { field: 'AccessionNumber', header: 'Accession Number', sortField: "document.AccessionNumber" };

  constructor(private columnsSvc: ResultColumnsService) {

  }

  ngOnInit(): void {
    this.selectedSortDirection = this.sortDirectionOptions[0];
    this.columnsSvc.selectedCols$.subscribe(cols => {
      this.selectedCols = cols; // load the selected columns as they change.

      //Add the Accession for sorting.
      const hasAccession = this.selectedCols.some(c => c.field === "AccessionNumber");
      if (!hasAccession)
        this.selectedCols.unshift(this.accessionNumberColumn);

    });
  }

  customSort() {
    if (this.selectedSortColumn && this.selectedSortColumn.field) {
      let sortDetails: SortDetails = { field: this.selectedSortColumn.field, order: this.selectedSortDirection.value };
      this.showSortReset = true;
      this.executeSort.emit(sortDetails);
    }
  }

  resetSort() {
    this.selectedSortColumn = '';
    this.selectedSortDirection = { name: "Descending", value: -1 };
    this.executeSortReset.emit();
  }
}
